import { render, staticRenderFns } from "./KeywordChart.vue?vue&type=template&id=18e66b49&scoped=true"
import script from "./KeywordChart.vue?vue&type=script&lang=js"
export * from "./KeywordChart.vue?vue&type=script&lang=js"
import style0 from "./KeywordChart.vue?vue&type=style&index=0&id=18e66b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e66b49",
  null
  
)

export default component.exports